import Link from 'next/link'
import './Button.css'

/** In-app route: client-side navigation instead of a full reload. `/api/*`
 *  (OAuth round trips) and anything off-site stay plain anchors. No viewport
 *  prefetch: it fetched the target's data during the landing's own load. */
export const isAppRoute = (href) =>
  typeof href === 'string' && href.startsWith('/') && !href.startsWith('//') && !href.startsWith('/api/')

/**
 * Primary action element. Renders an <a> when `href` is supplied so that
 * in-page navigation stays keyboard- and screen-reader-correct.
 */
export function Button({
  variant = 'primary',
  size = 'md',
  full = false,
  disabled = false,
  children,
  onClick,
  href,
  style,
  ...rest
}) {
  const cls =
    'u-btn u-btn--' + variant + ' u-btn--' + size + (full ? ' u-btn--full' : '')

  if (href && isAppRoute(href)) {
    return (
      <Link className={cls} href={href} prefetch={false} style={style} {...rest}>
        {children}
      </Link>
    )
  }

  if (href) {
    return (
      <a className={cls} href={href} style={style} {...rest}>
        {children}
      </a>
    )
  }

  return (
    <button
      type="button"
      className={cls}
      disabled={disabled}
      onClick={onClick}
      style={style}
      {...rest}
    >
      {children}
    </button>
  )
}

export default Button
